import CustomersService from '@services/customers-service.js'

export const state = {
    visitors: [],
}

export const mutations = {
    SET_STORE_VISITORS(state, { visitors }) {
        state.visitors = visitors
    },

    SET_STORE_VISITOR(state, { visitor }) {
        state.visitors.push(visitor)
    },

    REPLACE_STORE_VISITOR(state, { visitor, index }) {
        state.visitors.splice(index, 1, visitor)
    },
}

export const getters = {
    visitors: state => state.visitors,
    getVisitorByPersonId: state => personId => {
        return state.visitors.filter(
            visitor => visitor.personId === personId
        )[0]
    },
}

export const actions = {
    async getStoreVisitors({ commit, rootGetters }) {
        const visitors = await CustomersService.getStoreVisitors({
            storeId: rootGetters['stores/selectedStoreId'],
        })
        commit('SET_STORE_VISITORS', visitors)

        return visitors
    },

    setVisitor({ commit }, data) {
        commit('SET_STORE_VISITOR', data)
    },

    updateVisitor({ commit, state }, data) {
        const visitorId = data.visitor._id
        const index = state.visitors.findIndex(({ _id }) => _id === visitorId)
        const replaceData = {
            ...data,
            index,
        }

        ~index
            ? commit('REPLACE_STORE_VISITOR', replaceData)
            : commit('SET_STORE_VISITOR', data)
    },
}
